import React from "react"
import {
    TripCalendarDatePicker,
    componentStyles,
} from "@mallardbay/lib-react-components"

import type { ListingType } from "~graphql/generated/graphql"
import { useMobileMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import useCheckoutFlowDraftQuote from "~utils/use-checkout-flow-draft-quote"
import Box from "~components/shared/todo-lib-react-components/box"
import { DAYS_OF_WEEK } from "~config/constants"

interface Props {
    readonly availableDates: Date[]
    readonly dates: Date[]
    readonly openToDate?: Date | null
    readonly onChange: (dates: Date[]) => void
    readonly onMonthChange?: (date: Date) => void
    readonly isDisabled?: boolean
    readonly listingType: ListingType
    readonly isPricingPackageSetDay?: boolean
    readonly daysIncludedInPackage: number
    readonly isSingleMonth?: boolean
    readonly shouldHideHeader?: boolean
}

export default function DateSelect({
    availableDates,
    dates,
    openToDate,
    onChange,
    onMonthChange,
    isDisabled,
    listingType,
    isPricingPackageSetDay = false,
    daysIncludedInPackage,
    isSingleMonth = false,
    shouldHideHeader = false,
}: Props) {
    const styles = useStyles()
    const { draftQuote, isLoadingDraftQuote } = useCheckoutFlowDraftQuote()
    const { isMobileOnly } = useMobileMediaQueries()

    const shouldRenderSingleMonth = isSingleMonth || isMobileOnly

    return (
        <Box style={styles.container}>
            <TripCalendarDatePicker
                availableDates={availableDates}
                dates={dates}
                openToDate={openToDate}
                onChange={onChange}
                onMonthChange={onMonthChange}
                isDisabled={isDisabled}
                isLoading={isLoadingDraftQuote}
                listingType={listingType}
                tripItinerary={draftQuote?.itinerary}
                isPricingPackageSetDay={isPricingPackageSetDay}
                daysIncludedInPackage={daysIncludedInPackage}
                isSingleMonth={shouldRenderSingleMonth}
                shouldHideHeader={shouldHideHeader}
                calendarStartDayOfWeek={DAYS_OF_WEEK.SUNDAY}
            />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        container: {
            marginTop: "24px",
        },
    })
}
